export default __webpack_public_path__ + "static/img-366e86cee6981cf25bf25e5b81868884.png";